/* istanbul ignore file */
import React from 'react';
import SingleAssetBreadcrumbs from 'domain/finance/assets/shared/SingleAssetBreadcrumbs';
import { NotesBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useAssetId, useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';

const AssetTimelineBreadcrumbs = () => {
  const id = useAssetId();
  const { getTimelineUrl } = useAssetUrl();

  return (
    <SingleAssetBreadcrumbs>
      <NotesBreadcrumbItem link={getTimelineUrl(id)} />
    </SingleAssetBreadcrumbs>
  );
};

export default AssetTimelineBreadcrumbs;
